import React, { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter, useNavigate } from "react-router-dom";
import HomePage from "../pages/HomePage";
import UpcomingPage from "../pages/UpcomingPage";
import MatchPage from "../pages/MatchPage";
import StandingsPage from "../pages/StandingsPage";
import SearchPage from "../pages/SearchPage";
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";
import FantasyGamePage from "../pages/FantasyGamePage";
import MatchContestsPage from "../pages/MatchContestsPage";
import CreateTeamPage from "../pages/CreateTeamPage";
import CreatedTeamPage from "../pages/CreatedTeamPage";
import UserMatchesPage from "../pages/UserMatchesPage";
import PointsPage from "../pages/PointsPage";
import Auth from "../components/auth/Auth";
import RecentPage from "../pages/RecentPage";
import PageNotFound from "../pages/PageNotFound";
import NotificationsPage from "../pages/NotificationsPage";
import Profile from "../components/Profile";
import ErrorBoundary from "../components/ErrorBoundary";
import RequestsPage from "../pages/RequestsPage";
// import ActionPage from "../pages/ActionPage";
import SubscribePage from "../pages/SubscribePage";
import OtpPage from "../pages/OtpPage";
import GameConsentModal from "../pages/GameConsentModal";
import ProgressPage from "../pages/ProgressPage";
import axios from "axios";
import { baseUrl, baseUrlApi, checkFlow, GetHeadersConsole } from "../api/api";
import { v4 as uuidv4 } from "uuid";
// import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TermsAndCondition from "../pages/TermsAndCondition";
import ContentBlock from "../pages/ContentBlock";
import SubscribeNewPage from "../pages/SubscribeNewPage";
import HeadersPageNew from "../pages/HeadersPageNew";
import InsufficientFundsPage from "../pages/InsufficientFundsPage";
import TimeOutPage from "../pages/TimeOutPage";
import BlankPage from "../pages/BlankPage";
import classes from "../css/SubscribePage.module.css";
import Lottie from "lottie-react";

import loaderAnimation from "../animations/loader.json";
import BlockModal from "../components/BlockModal";
import SubscribePageFree from "../pages/SubscribePageFree";
import OtpPageNewFree from "../pages/OtpPageNewFree";
import HeadersPageNewFree from "../pages/HeadersPageNewFree";
import BlockModalFree from "../components/BlockModalFree";




// const InitialRedirect = ({ setFlowType, setMsisdn }) => {
//   const navigate = useNavigate();

//   const [apiId,setApiId] = useState('')

//   useEffect(() => {
//     const queryParams = new URLSearchParams(window.location.search);
//     let ext_ref = queryParams.get("ext_ref");

//     if (!ext_ref) {
//       ext_ref = localStorage.getItem("ext_ref") || uuidv4();
//       localStorage.setItem("ext_ref", ext_ref);
//     } else {
//       localStorage.setItem("ext_ref", ext_ref);
//     }

//     const callCheckFlow = async () => {
//       try {

//         const headers = {};
//         console.log(apiId)
//         if (apiId) headers["x-api-id"] = apiId;
//         const res = await axios.post(`${baseUrlApi}${checkFlow}?ext_ref=${ext_ref}`, {},{ headers });
//         console.log("CheckFlow response:", res.data);

        
//         if (res.data.statusCode == "200") {
//           const msisdnFromAPI = res.data.msisdn;
//           //  const msisdnFromAPI = '12387654'


//           if (msisdnFromAPI && msisdnFromAPI !== "Not Found") {
//             setMsisdn(msisdnFromAPI);
//             localStorage.setItem("msisdn", msisdnFromAPI);
//             setFlowType("mobile");
//             navigate(`/get-header?msisdn=${msisdnFromAPI}`);
//           } else {
//             setFlowType("wifi");
//            navigate("/subscribe"); // Or wherever you want to take wifi users
//           }
//         } else {
//           setFlowType("wifi");
//           navigate("/subscribe");
//         }
//       } catch (err) {
//         console.error("CheckFlow failed:", err);
//         toast.error("Network error – please try again.");
//         setFlowType("wifi");
//         // navigate("/home");
//       }
//     };

//     callCheckFlow();
//   }, [navigate, setFlowType, setMsisdn,apiId]);


//   const getHeaders=async()=>{
//     try{
//       const res = await axios.get(`${baseUrl}${GetHeadersConsole}`)
//       console.log(res.data,'res-----------------')

      
//       console.log(res.headers)
//       const apiIdHeader = res.headers["x-api-id"];
//       console.log(apiIdHeader,'api headers')
//       setApiId(apiIdHeader)

//       // setFlowType('headers')
//     }
//     catch(err){
//       console.log(err,'err---------')
//     }
//   }

//   useEffect(()=>{
//     getHeaders()
//   },[])

//   return null; // or a loader if you want
// };




// const InitialRedirect = ({ setFlowType, setMsisdn }) => {
//   const navigate = useNavigate();

//   const [header,setHeader] = useState(null)


//   const getHeaders=async()=>{
//     localStorage.clear()
//     let apiIdHeader = "";

//       try {
//         const res = await axios.get(`${baseUrl}${GetHeadersConsole}`);
//         console.log(res.data)

//         if(res?.data?.header){
//           apiIdHeader = res.data.header;
//           setFlowType("mobile");
//           navigate(`/get-header?msisdn=${apiIdHeader}`);
//         }
//         else{
//           navigate('/subscribe')
//         }
        
//         // console.log("API ID from headers:", apiIdHeader);
//         // setHeader(apiIdHeader)
//       } catch (error) {
//         console.log("Header fetch failed:", error);
//       }
//   }


//   const initFlow = async () => {

//       console.log('inti flow-----------------------------')
      

//       try {
//         const queryParams = new URLSearchParams(window.location.search);
//         let ext_ref = queryParams.get("ext_ref");

//         if (!ext_ref) {
//           ext_ref = localStorage.getItem("ext_ref") || uuidv4();
//           localStorage.setItem("ext_ref", ext_ref);
//         }

//         const headers = {};
        

//         const res = await axios.post(
//           `${baseUrlApi}${checkFlow}?ext_ref=${ext_ref}`,
//           {acrHeader:header},
//           { headers }
//         );

//         console.log("CheckFlow response:", res.data);

//         if (res.data.statusCode === "200") {
//           const msisdn = res.data.msisdn;

//           if (msisdn && msisdn !== "Not Found") {
//             setMsisdn(msisdn);
//             localStorage.setItem("msisdn", msisdn);

//             if (header) {
//               setFlowType("mobile");
//               navigate(`/get-header?msisdn=${msisdn}`);
//               return;
//             } else {
//               setFlowType("wifi");
//               navigate("/subscribe");
//               return;
//             }
//           }
//         }

//         // If MSISDN not found
//         setFlowType("wifi");
//         navigate("/subscribe");

//       } catch (err) {
//         console.error("CheckFlow failed:", err);
//         toast.error("Network error – please try again.");
//         setFlowType("wifi");
//         navigate("/subscribe");
//       }
//     };

//     useEffect(()=>{
//       getHeaders()
//     },[])

//   // useEffect(() => {
//   //   if(header){
//   //     initFlow();
//   //   }
//   //   else{
//   //     setTimeout(()=>{
//   //       navigate('/subscribe')
//   //     },7000)
//   //   }
//   // }, [header]);

//   return (
//           <div className={classes.loaderWrapper}>
//             <Lottie animationData={loaderAnimation} loop className={classes.loader} />
//           </div>
//   );
// };





// const InitialRedirect = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const storedMsisdn = localStorage.getItem("msisdn");

//     if (storedMsisdn) {
//       // setMsisdn(storedMsisdn);
//       // setFlowType("HOME");
//       navigate(`/home?msisdn=${storedMsisdn}`);
//     } else {
//       // setFlowType("SUBSCRIBE");
//       // navigate("/subscribe", { replace: true });
//       window.location.href = 'https://vd-kickwin.gameit.in/subscribe'
//     }
//   }, [navigate]);

//   return null; // no UI needed
// };







const Routing = () => {
  const [extRef, setExtRef] = useState("");
  const [msisdn, setMsisdn] = useState("");
   const [flowType, setFlowType] = useState("loading");
   const [loading, setLoading] = useState(true);



  const router = createBrowserRouter([
    {
      path: "/home",
      element: <HomePage />,
    },
    // {
    //   path:'/',
    //   element:<InitialRedirect />
    // },
    {
      path: "/recent/matches",
      element: <RecentPage />,
    },
    {
      path: "/upcoming/matches",
      element: <UpcomingPage />,
    },
    {
      path: "/match/:id/:homeTeamId/:awayTeamId",
      element: <MatchPage />,
    },
    {
      path: "/team/standings",
      element: <StandingsPage />,
    },
    {
      path: "/match/search",
      element: <SearchPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/signup",
      element: <SignupPage />,
    },
    {
      path: "/fantasy/game",
      element: <FantasyGamePage />,
    },
    {
      path: "/match/contests/:id/:homeTeamId/:awayTeamId",
      element: (
        <Auth>
          <MatchContestsPage />
        </Auth>
      ),
    },
    {
      path: "/match/create-team/:id/:homeTeamId/:awayTeamId/:contestId",
      element: (
        // <Auth>
          <CreateTeamPage />
        // </Auth>
      ),
    },
    {
      path: "/match/created-team/:id/:homeTeamId/:awayTeamId/:contestId",
      element: (
        // <Auth>
          <CreatedTeamPage />
        // </Auth>
      ),
    },
    {
      path: "/user/matches",
      element: <UserMatchesPage />,
    },
    {
      path: "/user/points",
      element: <PointsPage />,
    },
    {
      path: "/notifications",
      element: <NotificationsPage />,
    },
   
    {
    path: "/profile",
      element: 
      (
        // <Auth>
      <Profile/>
      //  </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
     {
      path: "/get-header",
      element: <HeadersPageNew />,
    },
    {
      path: "/get-header-new",
      element: <HeadersPageNewFree/>,
    },
    {
      path: "/action",
      element: <GameConsentModal />,
    },
    {
      path: "/subscribe",
      element: <SubscribeNewPage />,
    },
    {
      path: "/subscribe-new",
      element: <SubscribePageFree/>,
    },
     {
      path: "/otp",
      element: <OtpPage />,
    },
    {
      path: "/otp-new",
      element: <OtpPageNewFree/>,
    },
     {
      path: "/block",
      element: <ContentBlock />,
    },
     {
      path: "/insufficient-funds",
      element: <InsufficientFundsPage />,
    },
    {
      path: "/time-out",
      element: <TimeOutPage />,
    },
     {
      path: "/blank",
      element: <BlankPage />,
    },
     {
      path: "*",
      element: <PageNotFound />,
    },
    {
  path: "/progress",
  element: <ProgressPage />,
},
    {
  path: "/terms",
  element: <TermsAndCondition />,
},
 {
  path: "/consent",
  element: <BlockModal />,
},
 {
  path: "/consent-demo",
  element: <BlockModalFree />,
},

  ]);
  return <RouterProvider router={router} />;
};

export default Routing;
